export default __webpack_public_path__ + "static/media/card2.ae6c5ec7.jpg";